import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FieldItemWrapper from '../Components/FieldItemWrapper'
import RequiredFieldErrorMessage from '../Components/FieldItemWrapper/RequiredFieldErrorMessage'

import {
    FIELD_TYPE_COMPONENTS_TYPES,
    getFieldTypeRequiredErrorMessage,
} from 'packages/core'
import { TextField } from 'packages/eid-ui'

const FreeTextRange = ({ fieldType, isFormValidated, handleUpdate }) => {
    const { t } = useTranslation()
    const [errorMessageFrom, setErrorMessageFrom] = useState('')
    const [errorMessageTo, setErrorMessageTo] = useState('')

    useEffect(() => {
        if (
            isFormValidated &&
            (!fieldType?.AssignedValueFrom || !fieldType?.AssignedValueTo)
        ) {
            if (!fieldType?.AssignedValueFrom) {
                setErrorMessageFrom(getFieldTypeRequiredErrorMessage(fieldType))
                setErrorMessageTo('')
            } else {
                setErrorMessageTo(getFieldTypeRequiredErrorMessage(fieldType))
                setErrorMessageFrom('')
            }
        } else {
            setErrorMessageFrom('')
            setErrorMessageTo('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFormValidated,
        fieldType?.AssignedValueTo,
        fieldType?.AssignedValueFrom,
    ])

    const handleChange = (value, key) => {
        try {
            const valueToUpdate = {
                ...fieldType,
                [key]: value,
            }
            handleUpdate(valueToUpdate)
        } catch (err) {}
    }

    const bindErrorMessage = () => {
        return errorMessageFrom || errorMessageTo || ''
    }

    return (
        <Box
            sx={{
                marginBottom: '3rem',
            }}
        >
            <FieldItemWrapper
                title={fieldType?.Name}
                isRequired={fieldType?.IsRequired}
                fieldTypeScope={fieldType?.FieldTypeScope}
            >
                <Box
                    sx={{
                        fieldListWraper: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '2rem',
                            '& label': {
                                minWidth: '3.3rem',
                            },
                            '& input': {
                                maxWidth: '7rem',
                                color: '#3b454d',
                            },
                            '& .MuiFormControl-root': {
                                marginTop: '0 !important',
                                borderRadius: '0.4rem',
                                boxShadow:
                                    '0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
                            },
                        },
                        ...(fieldType?.IsReadOnly ||
                        fieldType?.SelectionRule ===
                            FIELD_TYPE_COMPONENTS_TYPES.FIXED_RANGE
                            ? {
                                  pointerEvents: 'none',
                                  opacity: '.6',
                                  cursor: 'not-allowed',
                              }
                            : {}),
                    }}
                >
                    <Box>
                        <TextField
                            margin={'none'}
                            onChange={(e) =>
                                handleChange(
                                    e.target.value,
                                    'AssignedValueFrom',
                                )
                            }
                            value={fieldType?.AssignedValueFrom || ''}
                            label={t('Common_From')}
                            error={Boolean(errorMessageFrom)}
                            disabled={
                                fieldType?.IsReadOnly ||
                                fieldType?.SelectionRule ===
                                    FIELD_TYPE_COMPONENTS_TYPES.FIXED_RANGE
                            }
                        />
                    </Box>
                    <Box>
                        <TextField
                            margin={'none'}
                            onChange={(e) =>
                                handleChange(e.target.value, 'AssignedValueTo')
                            }
                            value={fieldType?.AssignedValueTo || ''}
                            label={t('Common_To')}
                            error={Boolean(errorMessageTo)}
                            disabled={
                                fieldType?.IsReadOnly ||
                                fieldType?.SelectionRule ===
                                    FIELD_TYPE_COMPONENTS_TYPES.FIXED_RANGE
                            }
                        />
                    </Box>
                </Box>

                {(Boolean(errorMessageFrom) || Boolean(errorMessageTo)) && (
                    <RequiredFieldErrorMessage
                        errorMsgKey={bindErrorMessage()}
                        sx={{
                            ...(errorMessageTo && {
                                paddingLeft: '16rem !important',
                            }),
                        }}
                    />
                )}
            </FieldItemWrapper>
        </Box>
    )
}

export default FreeTextRange
